import { render, staticRenderFns } from "./ItemSelectMulti.vue?vue&type=template&id=b293f854"
import script from "./ItemSelectMulti.vue?vue&type=script&lang=js"
export * from "./ItemSelectMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports